/**
 * Simple hash router: #/path?query
 */
const listeners = new Set();

export function parseHash() {
  const raw = (location.hash || '#/').replace(/^#/, '') || '/';
  const [pathPart, queryPart = ''] = raw.split('?');
  const path = pathPart.startsWith('/') ? pathPart : `/${pathPart}`;
  const query = Object.fromEntries(new URLSearchParams(queryPart));
  const segments = path.split('/').filter(Boolean);
  return { path, query, segments, raw };
}

export function navigate(path, { replace = false } = {}) {
  const hash = path.startsWith('#') ? path : `#${path.startsWith('/') ? path : `/${path}`}`;
  if (replace) {
    const url = `${location.pathname}${location.search}${hash}`;
    history.replaceState(null, '', url);
    emit();
  } else {
    location.hash = hash.slice(1);
  }
}

export function onRoute(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function emit() {
  const route = parseHash();
  listeners.forEach((fn) => {
    try {
      fn(route);
    } catch (e) {
      console.error(e);
    }
  });
}

export function startRouter() {
  window.addEventListener('hashchange', emit);
  // initial
  if (!location.hash || location.hash === '#') {
    history.replaceState(null, '', `${location.pathname}${location.search}#/`);
  }
  emit();
}

export function linkClick(e, path) {
  if (e) e.preventDefault();
  navigate(path);
}
